/**
 * Did this booking SELL a membership, and through which path.
 *
 * `isMember` cannot answer that. It is true only for someone who arrived with
 * a `?membershipToken=` — an EXISTING member — and MembershipContext never
 * refetches, so a customer who joined 30 seconds ago at checkout is still
 * `false` at the confirmation step. Their booking was therefore indis-
 * tinguishable from a plain one-off on `booking_complete`, which is what
 * marketing computes CAC from.
 *
 * The signal is `membershipCheckoutInitiated` (AHD-7022): set right before the
 * Payment Element opens, synced immediately so a TWINT/Klarna/PayPal redirect
 * return restores it, and cleared when the user backs out to pay-later or
 * switches package type.
 *
 * NOT `selectedPaymentMode === "yearly"`, and that is the whole reason this
 * lives in its own function: sessionState.ts warns the store DEFAULTS the mode
 * to "yearly" outside the upsell surface, so keying on it would stamp plain
 * bookings as membership signups. The field is deliberately not a parameter
 * here — reaching for it again means changing this signature.
 */

export type MembershipSignupSource = "cadence" | "upsell" | "none";

export const membershipSignupSource = (opts: {
  /** Which membership path opened the Stripe checkout, if any. */
  membershipCheckoutInitiated?: "cadence" | "upsell" | null;
  /** Arrived with a membership token — an existing member. */
  isMember: boolean;
}): MembershipSignupSource => {
  // An existing member redeems; they cannot sign up again. Guarded so a stale
  // marker on a member's session can never report a second signup.
  if (opts.isMember) return "none";
  return opts.membershipCheckoutInitiated ?? "none";
};
